import { useEffect, useMemo, useState } from 'react';
import { ResponseModel } from 'model/utilModels/ResponseModel';
import CustomTableGrid from 'components/uiComponents/CustomTableGrid';
import { PaginatorModel } from 'model/utilModels/PaginatorModel';
import { conformationAlert } from 'services/shared/alert';
import { msgTypes } from 'constants/msgTypes';
import { Formik, Form } from 'formik'
import FormikControl from 'components/wrapperComponents/FormikControl';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { MemberBankDetailsService } from 'services/menu/memberBankDetailsService/MemberBankDetailsService';
import { RequestModel } from 'model/utilModels/RequestModel';
import { MemberBankDetailsModel } from 'model/screensModels/MemberBankDetailsModel';
import Tooltip from '@mui/material/Tooltip';



const MemberBankDetailsList = ({ setFlag, updateRecord, loadRecentBankDetails }) => {

  const [memberBankDetailsList, setMemberBankDetailsList] =  useState<ResponseModel | null>(null); 
  const paginatorModel: PaginatorModel = new PaginatorModel();
  const [pagination, setPagination] = useState({
    pageSize: paginatorModel.pageSize,
    pageNumber: paginatorModel.pageNumber,
    filter: "",
    orderBy: "",
    desc:"",
  })

  const columns = useMemo(() =>
    [
      {
        accessorKey: "companyName",
        header: "Company Name",
        size:150
      },
      {
        accessorKey: "accountHolderName",
        header: "Account Holder Name",
        size: 200
      },
      {
        accessorKey: "accountNumber",
        header: "Account Number",
        size:150
      },
      {
        accessorKey: "bankName",
        header: "Bank Name",
        size:150
      },
      {
        accessorKey: "countryName",
        header: "Country Name",
        size:150
      },
      {
        accessorKey: "currency",
        header: "Currency",
        size:150
      },
      {
        accessorKey: "type",
        header: "Type",
        size:120
      },
      {
        header: 'Action',
        Cell: ({ renderedCellValue, row }) => (
          <div className='d-flex'>
          <Tooltip title="Edit">
              <EditIcon fontSize="small" onClick={()=>{editRecord(row.original)}} />
            </Tooltip>
            <Tooltip title="Delete">
              <DeleteIcon fontSize="small" onClick={()=>{deleteRecord(row.original)}} />
            </Tooltip>
          </div>
        ),
        size: 10,
        grow: false,
      },

    ], []);

  // //Begin:: UseEffect Hooks 

  useEffect(() => {
    getBankDetailsList();
  }, [pagination.pageNumber, pagination.pageSize, pagination.filter, pagination.orderBy, pagination.desc]);
  
  

  //End:: UseEffect Hooks 


  //Prepare request body to get blog list
  const prepareRequest = () => {
    const requestBody = new RequestModel();
    requestBody.pageNumber = pagination.pageNumber;
    requestBody.pageSize = pagination.pageSize;
    requestBody.filter = pagination.filter;
    requestBody.orderBy = pagination.orderBy;
    requestBody.desc = pagination.desc;
    return requestBody;
  }

  //Get Member Bank Details list
  const getBankDetailsList = async () => {
    const requestBody = prepareRequest();
     const res = await MemberBankDetailsService.getBankDetails(requestBody);  
      if (res.statusMsg === msgTypes.SUCCESS.msg) {
        setMemberBankDetailsList(res);  
      }  
   }


  

  //Open Form To edit Record
  const editRecord = (record: MemberBankDetailsModel) => {
    updateRecord(record);
    setFlag(true)
  }

  const deleteRecord = async (record: MemberBankDetailsModel) => {
    const requestData: MemberBankDetailsModel = new MemberBankDetailsModel();
    requestData.bankId = record.bankId;

    const deleteFlag = await conformationAlert(msgTypes.CONFORMATION_MESSAGE.DELETE_RECORD, msgTypes.CONFORMATION_ICON.ERROR, "delete");
    if(deleteFlag) {
      const res = await MemberBankDetailsService.deleteBankDetails(requestData);
      if (res.statusMsg === msgTypes.SUCCESS.msg) {
        getBankDetailsList();
        loadRecentBankDetails();
      }
    }
  }


  const initialValues = {}
  const onSubmit = () => {
    getBankDetailsList();
  }

  

  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValues}
      // validationSchema={BlogSchema}
      onSubmit={onSubmit}
    >
      {
        formik =>
        (
          <Form>  {memberBankDetailsList ? (
                    <CustomTableGrid
                      item={
                      <FormikControl 
                          control='materialTable'
                          tableColumn={columns}
                          tableData={memberBankDetailsList}
                          setPagination={setPagination}
                      />
                      }
                    />
                  ) : null}
          </Form>
        )
      }
    </Formik>
  )
}
export default MemberBankDetailsList;
